// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".style-module__extensionList___ZVHdA {\n  padding: 15px;\n}\n", "",{"version":3,"sources":["webpack://./src/components/Body/InstalledExtensions/ExtensionList/style.module.less"],"names":[],"mappings":"AAAA;EACI,aAAA;AACJ","sourcesContent":[":local(.extensionList){\n    padding: 15px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"extensionList": "style-module__extensionList___ZVHdA"
};
module.exports = ___CSS_LOADER_EXPORT___;
